import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {entities as entitiesAction} from 'actions'
import useUserLoginStatus from './useUserLoginStatus'

function useFetchApiKey () {
  const dispatch = useDispatch()
  const isLogin = useUserLoginStatus()

  const fetchData = useCallback(async () => {
    if (!isLogin) return
    const res = await ApiSdk.futures.getApiKeys()
    dispatch(entitiesAction({apiKey: res?.getApiKeys ? res?.getApiKeys[0] : {}}))
  }, [dispatch, isLogin])

  useEffect(() => {
    if (!isLogin) return
    fetchData()
  }, [dispatch, fetchData, isLogin])
}

export default useFetchApiKey
